import r from "./r.svg";
import l from "./l.svg";
import bl from "./bl.svg";
import br from "./br.svg";
import tr from "./tr.svg";
import tl from "./tl.svg";

export const lines = { r, l, bl, br, tr, tl };
